import { render, staticRenderFns } from "./ProductCreateView.vue?vue&type=template&id=2737dc94"
import script from "./ProductCreateView.vue?vue&type=script&lang=js"
export * from "./ProductCreateView.vue?vue&type=script&lang=js"
import style0 from "./ProductCreateView.vue?vue&type=style&index=0&id=2737dc94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports